import axios from 'axios';

export default {
  data() {
    return {
      current_user: {},
      current_user_available: false,
    };
  },
  methods: {
    async getCurrentUser() {
      await axios.get('/api/v1/auth/get-current-user')
        .then((response) => {
          this.current_user = response.data;
        }).catch((error) => {
          console.log(error);
        });

      return this.current_user.hasOwnProperty('admin_id');
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/mixins/permissions.js